<script lang="ts">
	import StoreDetailViewer from "../component/Store/StoreDetailViewer.svelte";
	import SalesTransfer from "@hitit/hub/src/v7/components/store/SalesTransfer.svelte";
	import StoreBuisnesshour from "@hitit/hub/src/v7/components/store/StoreBuisenesshour.svelte";
	import StoreOrganization from "@hitit/hub/src/v7/components/store/StoreOrganization.svelte";
	//Utils
	import type {
		ATU_SettingDTO,
		AccessControlDTO,
		GeneralSettingDTO,
		PaymentSettingDTO,
		PlaceDTO,
		StoreData,
	} from "@hitit/api";
	import { t, api, notifications } from "@hitit/hub/src/stores";
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	import { onDestroy } from "svelte";
	import { popup } from "@hitit/hub/src/v7/store";
	import CardMembershipInfoWidget from "../component/Store/CardMembershipInfoWidget.svelte";
	import GeneralSettingWidget from "../component/Store/GeneralSettingWidget.svelte";
	import PaymentSettingWidget from "../component/Store/PaymentSettingWidget.svelte";
	import AtuSettingWidget from "../component/Store/AtuSettingWidget.svelte";
	import {
		addSpacer,
		getNationalPhonenumber,
	} from "@hitit/hub/src/functions/utils/phone";
	import SelfOrderManage from "../component/Store/SelfOrder/SelfOrderManage.svelte";

	export let storeId = "";

	enum components {
		BUISNESS_HOUR,
		SALES_TRANSFER,
		STORE_INFOMATION,
		MANAGE_ADMIN,
		GENERAL_SETTING,
		ATU_SETTING,
		CARD_MEMBERSHIP_INFO,
		PAYMENT_SETTING,
	}

	const editStatus = {
		[components.BUISNESS_HOUR]: false,
		[components.SALES_TRANSFER]: false,
		[components.STORE_INFOMATION]: false,
		[components.MANAGE_ADMIN]: false,
		[components.GENERAL_SETTING]: false,
		[components.ATU_SETTING]: false,
		[components.CARD_MEMBERSHIP_INFO]: false,
		[components.PAYMENT_SETTING]: false,
	};

	const coverStatus = (status: boolean) => {
		const hasEdit = Object.values(editStatus).reduce((prev, cur) => {
			if (cur === true) {
				return true;
			}
			return prev;
		}, false);

		if (hasEdit && !status) {
			return true;
		} else {
			return false;
		}
	};

	let store: StoreData | undefined;
	let place: PlaceDTO | undefined;
	let accessControlDTOs: AccessControlDTO[] | undefined;
	let paymentSetting: PaymentSettingDTO | null;
	let generalSetting: GeneralSettingDTO | null;
	let AtuSetting: ATU_SettingDTO | null;
	let storeOwnerNumber: any;
	let loading = false;
	async function loadStore(qStoreId: string) {
		try {
			loading = true;
			const [
				storeResult,
				placeResult,
				accessControlResult,
				// getPaymentResponse,
				// getGeneralResponse,
				// getAtuResponse,
			] = await Promise.allSettled([
				$api.getStore(qStoreId),
				$api.getPlaceInfomation(qStoreId),
				$api.getAccessControlByStoreId(qStoreId),
				// $api.getPaymentSetting(qStoreId),
				// $api.getGeneralSetting(qStoreId),
				// $api.getAtuSetting(qStoreId),
			]);

			if (qStoreId !== storeId) return;

			if (storeResult.status === "fulfilled") {
				store = storeResult.value.data.result.find((v) => v.id === qStoreId);
			} else {
				console.warn("getStore 실패:", storeResult.reason);
				notifications.append(
					"ERROR",
					"스토어 정보를 불러오지 못했습니다.",
					"",
					undefined,
					"WARNING"
				);
			}

			// --- place ---
			if (placeResult.status === "fulfilled") {
				place = placeResult.value.data.placeDTO;
			} else {
				console.warn("getPlaceInfomation 실패:", placeResult.reason);
				notifications.append(
					"ERROR",
					"매장 정보를 불러오지 못했습니다.",
					"",
					undefined,
					"WARNING"
				);
			}

			// --- accessControl ---
			if (accessControlResult.status === "fulfilled") {
				const list =
					accessControlResult.value.data.accessControlListDTO.accessControlDTOList.map(
						(v) => ({ ...v, username: v.username || "" })
					);

				accessControlDTOs = list;
				const storeOwner = list.find((v) => v.permission === "STOREOWNER");

				if (storeOwner) {
					storeOwnerNumber = addSpacer(
						getNationalPhonenumber(
							storeOwner.cellphone,
							storeOwner.cellphoneCountryCode
						)
					);
				}
			} else {
				console.warn(
					"getAccessControlByStoreId 실패:",
					accessControlResult.reason
				);
				notifications.append(
					"ERROR",
					"접근 제어 정보를 불러오지 못했습니다.",
					"",
					undefined,
					"WARNING"
				);
			}

			// place = getPlaceResponse.data.placeDTO;
			// store = getStoreResponse.data.result.find((v) => v.id === qStoreId);
			// accessControlDTOs =
			// 	getStoreAccessControlResponse.data.accessControlListDTO.accessControlDTOList.map(
			// 		(v) => ({ ...v, username: v.username || "" })
			// 	);

			// const storeOwner = accessControlDTOs.filter(
			// 	(v) => v.permission === "STOREOWNER"
			// )[0];

			// storeOwnerNumber = addSpacer(
			// 	getNationalPhonenumber(
			// 		storeOwner.cellphone,
			// 		storeOwner.cellphoneCountryCode
			// 	)
			// );
			// paymentSetting = getPaymentResponse.data.paymentSettingDTO;
			// generalSetting = getGeneralResponse.data.generalSettingDTO;
			// AtuSetting = getAtuResponse.data.atuSettingDTO;
		} catch (error) {
			notifications.append(
				"ERROR",
				"관리자에게 문의해주세요.",
				"",
				undefined,
				"WARNING"
			);
			console.log(error);
		} finally {
			loading = false;
		}
	}

	$: loadStore(storeId);
	onDestroy(() => {
		$popup = undefined;
	});
</script>

{#if loading}
	<ContainerLoading />
{/if}
{#if store && place && accessControlDTOs}
	<div class="container" t-id="Store">
		<div class="left-contents">
			<StoreDetailViewer
				bind:store={store}
				coverStatus={coverStatus(editStatus[components.STORE_INFOMATION])}
				bind:editmode={editStatus[components.STORE_INFOMATION]}
			/>
		</div>
		<div class="right-contents">
			<StoreBuisnesshour
				storeId={storeId}
				placeDTO={place}
				coverStatus={coverStatus(editStatus[components.BUISNESS_HOUR])}
				bind:editmode={editStatus[components.BUISNESS_HOUR]}
			/>
			<SalesTransfer
				bind:store={store}
				coverStatus={coverStatus(editStatus[components.SALES_TRANSFER])}
				bind:editmode={editStatus[components.SALES_TRANSFER]}
			/>
			<!-- <CardMembershipInfoWidget
				coverStatus={coverStatus(editStatus[components.CARD_MEMBERSHIP_INFO])}
				bind:editmode={editStatus[components.CARD_MEMBERSHIP_INFO]}
				editable
			/> -->
			<StoreOrganization
				bind:editmode={editStatus[components.MANAGE_ADMIN]}
				storeId={store.id}
				coverStatus={coverStatus(editStatus[components.MANAGE_ADMIN])}
				accessControlList={accessControlDTOs}
				editable
			/>
			<!-- <GeneralSettingWidget
				coverStatus={coverStatus(editStatus[components.GENERAL_SETTING])}
				bind:editmode={editStatus[components.GENERAL_SETTING]}
				generalSetting={generalSetting}
				storeId={storeId}
				editable
			/>
			<PaymentSettingWidget
				coverStatus={coverStatus(editStatus[components.PAYMENT_SETTING])}
				bind:editmode={editStatus[components.PAYMENT_SETTING]}
				paymentSetting={paymentSetting}
				storeId={storeId}
				editable
			/>
			<AtuSettingWidget
				coverStatus={coverStatus(editStatus[components.ATU_SETTING])}
				bind:editmode={editStatus[components.ATU_SETTING]}
				AtuSetting={AtuSetting}
				storeId={storeId}
				storeOwnerNumber={storeOwnerNumber}
				editable
			/>
			<SelfOrderManage storeId={storeId} /> -->
		</div>
	</div>
{/if}

<style lang="scss">
	@import "../../variables.scss";

	div {
		box-sizing: border-box;
	}
	.container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 20px;
		width: 100%;
		padding-top: 50px;

		.left-contents {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			gap: 20px;
		}

		.right-contents {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			gap: 20px;
		}
	}

	@include DesktopSize {
		.container {
			flex-direction: row;
			gap: 30px;
			padding-top: 0px;

			.left-contents {
				width: 55%;
			}

			.right-contents {
				width: 45%;
			}

			@media screen and (max-width: 1520px) {
				flex-direction: column;

				.left-contents,
				.right-contents {
					width: 100%;
				}
			}
		}
	}
</style>
